__turbopack_context__.v({
  "carousel": "styles-module__gWVgvW__carousel",
  "dragging": "styles-module__gWVgvW__dragging",
});
